import React from 'react'
import './ErrorMessage.css'
import Info from "../../../assets/images/svgs/Info.svg?react"
import { useSelector } from 'react-redux';

const ErrorMessage = () => {
    const showOrbit = useSelector(state => state.orderDetails.showOrbit);    
  return (
    <div className='ErrorMessage-box'>
        <Info />
        <div>{showOrbit?.errorMessage}</div>
    </div>
  )
}

export default ErrorMessage